import React from "react";
import http from "../../../services/http-common";

const Read = (fileName, ownerId, prj_no, process) => {
    const project_no = prj_no? prj_no :'tempFiles';
    const process_ = process? process :'document'
    return http.get(`/files/${project_no}/${ownerId}/${fileName}/${process_}`)
};

export default Read;